/** @import Issuer from '@/classes/facturae/Issuer' */
/** @import TaxWithHeld from '@/classes/facturae/TaxWithHeld' */
/** @import InvoiceLine from '@/classes/facturae/InvoiceLine' */
/** @import File from '@/classes/facturae/File' */

/** @type {SimplificadaData} */
export default class SimplificadaData {
  /** @type {number|null} */ IdCliente = null
  /** @type {number?} */ tipoImpuestoFactura = null
  /** @type {Issuer?} */ issuer = null
  /** @type {string?} */ serieFactura = null
  /** @type {string?} */ numFactura = null
  /** @type {Date?} */ dateEmision = null
  /** @type {Date?} */ dateVencimiento = null
  /** @type {string?} */ albaran = null
  /** @type {string?} */ pedido = null
  /** @type {string?} */ observaciones = null
  /** @type {string?} */ numExpediente = null
  /** @type {Date?} */ dateExpediente = null
  /** @type {string?} */ numEmisor = null
  /** @type {Date?} */ dateEmisor = null
  /** @type {string?} */ codAsignacion = null
  /** @type {Date?} */ dateReceptor = null
  /** @type {string?} */ dir3 = null
  /** @type {string?} */ numContrato = null
  /** @type {string?} */ codDepReceptor = null
  /** @type {TaxWithHeld?} */ taxesWithHeld = null
  /** @type {number?} */ cuotaSuplido = null
  /** @type {Date?} */ periodoDesde = null
  /** @type {Date?} */ periodoHasta = null
  /** @type {Array<InvoiceLine>?} */ invoiceLines = null
  /** @type {Array<File>?} */ Adjuntos = null
  /** @type {number|null} */ idPlantilla = null
  /** @type {File|null} */ file = null
  /** @type {boolean?} */ applyEquivalenceSurcharge = null
}
